import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import PopoverWrap from 'components/@common/Popover';
import { Typography } from '@material-ui/core';
import ProfileField from './ProfileField';

export interface ProfileDetailsEditProps {
  classes: { [key: string]: string };
}

const EditProfileDetails = ({ classes }: ProfileDetailsEditProps): ReactElement => {
  const { t } = useTranslation('CreateClassStep');

  return (
    <>
      <ProfileField name="firstName" t={t} label="First Name" />
      <ProfileField name="lastName" t={t} label="Last Name" />
      <div className={classes.selectorLabel}>
        <PopoverWrap
          title="Educator PIN"
          key="pin_selector_label_popover"
          description={
            'You will need your Educator PIN for student device setup. Educator PIN should be 6 to 24 characters long and can only contain letters and numbers.'
          }
        >
          <Typography key="pin_selector_label" variant="h3">
            {t('Change Educator PIN')}
          </Typography>
        </PopoverWrap>
      </div>
      <ProfileField name="oldPin" t={t} label="Current Educator PIN" disabled={true} />
      <ProfileField name="pin" t={t} label="New Educator PIN" />
    </>
  );
};

export default EditProfileDetails;
